module.exports = __webpack_public_path__ + "f66b0cf3ab573715ce7fadb693f9702b.png";